export default class AppInstallPrompt {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		// get references to required elements
		this.installButton = this.options.installButton;
		this.dismissButton = this.options.dismissButton;

		this.deferredPrompt = null;

		this.watch();
	}
	watch() {
		window.addEventListener(
			"beforeinstallprompt",
			this.onPromptAvailable.bind(this)
		);
		this.installButton.addEventListener(
			"click",
			this.requestPrompt.bind(this)
		);
		this.dismissButton.addEventListener(
			"click",
			this.dismissInvite.bind(this)
		);
	}

	onPromptAvailable(event) {
		event.preventDefault();
		this.deferredPrompt = event;
		this.displayInvite();
	}

	displayInvite() {
		this.element.hidden = false;
	}

	dismissInvite() {
		this.element.hidden = true;
		this.callCookieApi();
	}

	requestPrompt() {
		this.deferredPrompt.prompt();
		this.deferredPrompt.userChoice.then((choice) => {
			this.deferredPrompt = null;
			this.dismissInvite();
		});
	}

	callCookieApi() {
		const cookieId = encodeURIComponent(this.options.cookieId);
		const cookieRequest = new Request(
			`${this.options.cookieApi}?id=${cookieId}`
		);
		fetch(cookieRequest);
	}
}



// WEBPACK FOOTER //
// ./project/client/src/core/components/app-install-prompt/app-install-prompt.js